import React from 'react'
import { useHistory } from 'react-router-dom'
import type { LinkProps } from '@paintscout/ui'
import { Link } from '@paintscout/ui'
import { useLocationTracker } from '../../context'

export interface BackLinkProps extends Omit<LinkProps, 'to' | 'children'> {
  to?: LinkProps['to']
  children: React.ReactNode | ((previousLocation?: { pathname: string }) => React.ReactNode)
}

export default function BackLink({ children, ...props }: BackLinkProps) {
  const { history: sessionHistory, removeLastEntry } = useLocationTracker()
  const history = useHistory()

  const previousLocationPath = sessionHistory.at(-2) ?? ''

  const to = props.to && (typeof props.to === 'string' ? props.to : (props.to as any).pathname)

  const isBack = !props.to || previousLocationPath === to

  return (
    <Link
      {...props}
      to={to || previousLocationPath || ''}
      onClick={(e: any) => {
        console.log({ isBack, previousLocationPath, history, sessionHistory, to })
        if (isBack && previousLocationPath) {
          e.preventDefault()
          removeLastEntry()
          history.push(previousLocationPath)
        }
      }}
    >
      {typeof children === 'function' ? children({ pathname: previousLocationPath }) : children}
    </Link>
  )
}
